function geoCheck() {
  const userCountry = localStorage.getItem('userCountry');

  if (!userCountry) {
    fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json?country[enabled]=true`)
      .then(res => res.json())
      .then(res => {
        const countryHandle = res.detected_values.country.handle;
        document.body.classList.add(`country-${countryHandle.toLowerCase()}`);
    });
  } else {
    document.body.classList.add(`country-${userCountry.toLowerCase()}`);
  }
}

geoCheck();